'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'list-timeline';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e1d1';
var svgPathData = 'M208 486.6c6 6 14.1 9.4 22.6 9.4L416 496c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-185.4 0c-8.5 0-16.6 3.4-22.6 9.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6L208 486.6zM221.3 80l16-16 162.7 0 0 32-162.7 0-16-16zm0 176l16-16 226.7 0 0 32-226.7 0-16-16zm0 176l16-16 162.7 0 0 32-162.7 0-16-16zM208 25.4L164.7 68.7c-6.2 6.2-6.2 16.4 0 22.6L208 134.6c6 6 14.1 9.4 22.6 9.4L416 144c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L230.6 16c-8.5 0-16.6 3.4-22.6 9.4zM230.6 192c-8.5 0-16.6 3.4-22.6 9.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6L208 310.6c6 6 14.1 9.4 22.6 9.4L480 320c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-249.4 0zM64 48a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 176a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faListTimeline = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;